export const TableTab = {
  Certificates: "certificates",
  PassHistory: "passHistory",
};
